module.exports = __webpack_public_path__ + "img/BE0455297412.811ac550.png";